import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { GrupoDespesaService } from '../services/grupo-despesa.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-grupos-despesa-edit',
	templateUrl: './grupos-despesa-edit.component.html',
	styleUrls: ['./grupos-despesa-edit.component.css'],
	animations: [loadingFade]
})
export class GruposDespesaEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public grupo_despesa_id = null;

	public formGrupoDespesa: FormGroup;

	constructor(private route: ActivatedRoute,
				private fb: FormBuilder,
				private grupoDespesaSvc: GrupoDespesaService,
				private router: Router) { }

	ngOnInit() {
		this.criaForm();
		this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {
				this.grupo_despesa_id = params.id;
				// pega dados a partir do id
				this.grupoDespesaSvc.getGrupoDespesa(params.id).then((data: any) => {
					this.preencheForm({
						grupo_despesa_id: data.grupo_despesa_id,
						grupo_despesa_nome: data.grupo_despesa_nome
					});
					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formGrupoDespesa = this.fb.group({
			grupo_despesa_id: null,
			grupo_despesa_nome: ['', Validators.required]
		});
	}

	preencheForm(dados) {
		this.formGrupoDespesa.setValue(dados);
	}

	enviaGrupoDespesa() {
		if (this.formGrupoDespesa.valid) {
			this.submitting = true;

			let toSend = this.formGrupoDespesa.value;

			if (this.grupo_despesa_id === null) { // criar
				this.grupoDespesaSvc.criaGrupoDespesa(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Grupo de despesa cadastrado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/gruposdespesa']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.grupoDespesaSvc.editaGrupoDespesa(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Grupo de despesa cadastrado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/gruposdespesa']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else{
			for( let field in this.formGrupoDespesa.controls){
				let campo = this.formGrupoDespesa.get(field);
				campo.markAsTouched();
			}
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formGrupoDespesa.get(nome);
		return input.touched && input.invalid;
	}
}
